export const incomingMessagesTypes = {
  Acknowledged: "ACKNOWLEDGED",
  Alert: "ALERT",
  CheckConnectivity: "CHECK_CONNECTIVITY",
  // the type above can be removed once no Alerter still has this message type stored (global find 'CheckConnectivity' for more details)
  ConnectivityCheckToMessagingServers:
    "CONNECTIVITY_CHECK_TO_MESSAGING_SERVERS",
  NoOp: "NOOP",
  Silence: "SILENCE",
};
